import { useEffect } from "react";
import { useSelector } from "react-redux";
import { LOGIN_URL } from "@constants/routes";
import { useModalContext } from "@context/use-modal-context";
import { ModalTypes } from "@enums/modal-types";
import { getHostnameWithScheme } from "@utils/http-util";
import { isStringNumber } from "@utils/string-util";
import { SessionTimeoutWarningModal } from "../containers/modals/session-timeout-warning-modal/session-timeout-warning-modal";
import { getSessionState } from "@redux/selectors/root-selectors";

export const useSessionMonitor = () => {
    const modalContext = useModalContext();
    const { session, requestCount } = useSelector(getSessionState);

    const renderSessionTimeoutWarningModal = (onModalClose: () => void) => {
        return <SessionTimeoutWarningModal onModalClose={onModalClose} />;
    };

    useEffect(() => {
        let sessionTimeout: NodeJS.Timeout;
        let sessionTimeoutWarning: NodeJS.Timeout;
        if (session && isStringNumber(session.sessionTimeout)) {
            const sessionTimeoutInMs = parseInt(session.sessionTimeout) * 60 * 1000;
            const sessionTimeoutWarningInMs = sessionTimeoutInMs - (5 * 60 * 1000);

            sessionTimeoutWarning = setTimeout(() => {
                modalContext.setModalState({
                    modalType: ModalTypes.SessionTimeoutWarning,
                    renderFunction: renderSessionTimeoutWarningModal
                });
            }, sessionTimeoutWarningInMs);

            sessionTimeout = setTimeout(() => {
                const loginUrl = `${getHostnameWithScheme()}${LOGIN_URL}?errorCode=SESSION_TIMEOUT`;
                window.location.href = loginUrl;

            }, sessionTimeoutInMs);
        }

        return () => {
            if (sessionTimeout) {
                clearTimeout(sessionTimeout);
            }
            if (sessionTimeoutWarning) {
                clearTimeout(sessionTimeoutWarning);
            }
        };
    }, [session, requestCount]);

};